import { createListPage, createDeletedListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/bottles'
import { dialogTypes } from 'dialogs'
import Content from './grid'
import Form from './form'
import { default as AboveContent } from './filters'

import { urls } from 'urls'

const PAGE = 'bottles'

export const metadata = {
  icon: 'glass',
  page: PAGE,
  urls: urls[PAGE],
  isSoftDelete: true,
  detailDialog: dialogTypes.bottleDetail,
  useDetailDialog: true
}

const BottlesListPage = createListPage({ metadata, api, actionCreators, Content, AboveContent })
const DeletedBottlesListPage = createDeletedListPage({ metadata, api, actionCreators, Content })
const BottlesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { BottlesListPage, DeletedBottlesListPage, BottlesDetailPage }
